import {
  hmplusLimitedReleaseDetailConstants,
  createHMplusLimitedReleaseDetailConstants,
  editHMplusLimitedReleaseDetailConstants,
  addTargetHMplusLimitedReleaseDetailConstants,
  removeTargetHMplusLimitedReleaseDetailConstants,
  activateHMplusLimitedReleaseDetailConstants,
  deactivateHMplusLimitedReleaseDetailConstants,
  deleteHMplusLimitedReleaseDetailConstants,
} from "../_redux-constants";
import { hmplusLimitedReleasesDetailService } from "../../_services";
import { errorExtractor } from "../../_helpers";

function getHMplusLimitedReleaseDetail(queryParams) {
  function getHMplusLimitedReleaseDetailLoad() {
    return {
      type: hmplusLimitedReleaseDetailConstants.HMPLUS_LIMITED_RELEASE_DETAIL_LOADING,
    };
  }
  function getHMplusLimitedReleaseDetailSuccess(data) {
    return {
      type: hmplusLimitedReleaseDetailConstants.HMPLUS_LIMITED_RELEASE_DETAIL_SUCCESS,
      data,
    };
  }
  function getHMplusLimitedReleaseDetailFailure(error) {
    return {
      type: hmplusLimitedReleaseDetailConstants.HMPLUS_LIMITED_RELEASE_DETAIL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(getHMplusLimitedReleaseDetailLoad());
    return hmplusLimitedReleasesDetailService
      .getHMplusLimitedReleaseDetail(queryParams)
      .then(
        (data) => {
          dispatch(getHMplusLimitedReleaseDetailSuccess(data));
        },
        (error) => {
          dispatch(getHMplusLimitedReleaseDetailFailure(error?.toString()));
        }
      );
  };
}

function createHMplusLimitedReleaseDetail(requestBody, queryParams) {
  function createHMplusLimitedReleaseDetailLoad() {
    return {
      type: createHMplusLimitedReleaseDetailConstants.CREATE_HMPLUS_LIMITED_RELEASE_DETAIL_LOADING,
    };
  }
  function createHMplusLimitedReleaseDetailSuccess(data) {
    return {
      type: createHMplusLimitedReleaseDetailConstants.CREATE_HMPLUS_LIMITED_RELEASE_DETAIL_SUCCESS,
      data,
    };
  }
  function createHMplusLimitedReleaseDetailFailure(error) {
    return {
      type: createHMplusLimitedReleaseDetailConstants.CREATE_HMPLUS_LIMITED_RELEASE_DETAIL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(createHMplusLimitedReleaseDetailLoad());
    return new Promise((resolve, reject) => {
      hmplusLimitedReleasesDetailService
        .createHMplusLimitedReleaseDetail(requestBody, queryParams)
        .then(
          (data) => {
            dispatch(createHMplusLimitedReleaseDetailSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(
              createHMplusLimitedReleaseDetailFailure(error?.toString())
            );
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function editHMplusLimitedReleaseDetail(requestBody, queryParams) {
  function editHMplusLimitedReleaseDetailLoad() {
    return {
      type: editHMplusLimitedReleaseDetailConstants.EDIT_HMPLUS_LIMITED_RELEASE_DETAIL_LOADING,
    };
  }
  function editHMplusLimitedReleaseDetailSuccess(data) {
    return {
      type: editHMplusLimitedReleaseDetailConstants.EDIT_HMPLUS_LIMITED_RELEASE_DETAIL_SUCCESS,
      data,
    };
  }
  function editHMplusLimitedReleaseDetailFailure(error) {
    return {
      type: editHMplusLimitedReleaseDetailConstants.EDIT_HMPLUS_LIMITED_RELEASE_DETAIL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(editHMplusLimitedReleaseDetailLoad());
    return new Promise((resolve, reject) => {
      hmplusLimitedReleasesDetailService
        .editHMplusLimitedReleaseDetail(requestBody, queryParams)
        .then(
          (data) => {
            dispatch(editHMplusLimitedReleaseDetailSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(editHMplusLimitedReleaseDetailFailure(error?.toString()));
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function addTargetHMplusLimitedReleaseDetail(requestBody, queryParams) {
  function addTargetHMplusLimitedReleaseDetailLoad() {
    return {
      type: addTargetHMplusLimitedReleaseDetailConstants.ADD_TARGET_HMPLUS_LIMITED_RELEASE_DETAIL_LOADING,
    };
  }
  function addTargetHMplusLimitedReleaseDetailSuccess(data) {
    return {
      type: addTargetHMplusLimitedReleaseDetailConstants.ADD_TARGET_HMPLUS_LIMITED_RELEASE_DETAIL_SUCCESS,
      data,
    };
  }
  function addTargetHMplusLimitedReleaseDetailFailure(error) {
    return {
      type: addTargetHMplusLimitedReleaseDetailConstants.ADD_TARGET_HMPLUS_LIMITED_RELEASE_DETAIL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(addTargetHMplusLimitedReleaseDetailLoad());
    return new Promise((resolve, reject) => {
      hmplusLimitedReleasesDetailService
        .addTargetHMplusLimitedReleaseDetail(requestBody, queryParams)
        .then(
          (data) => {
            dispatch(addTargetHMplusLimitedReleaseDetailSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(
              addTargetHMplusLimitedReleaseDetailFailure(error?.toString())
            );
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function removeTargetHMplusLimitedReleaseDetail(queryParams) {
  function removeTargetHMplusLimitedReleaseDetailLoad() {
    return {
      type: removeTargetHMplusLimitedReleaseDetailConstants.REMOVE_TARGET_HMPLUS_LIMITED_RELEASE_DETAIL_LOADING,
    };
  }
  function removeTargetHMplusLimitedReleaseDetailSuccess(data) {
    return {
      type: removeTargetHMplusLimitedReleaseDetailConstants.REMOVE_TARGET_HMPLUS_LIMITED_RELEASE_DETAIL_SUCCESS,
      data,
    };
  }
  function removeTargetHMplusLimitedReleaseDetailFailure(error) {
    return {
      type: removeTargetHMplusLimitedReleaseDetailConstants.REMOVE_TARGET_HMPLUS_LIMITED_RELEASE_DETAIL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(removeTargetHMplusLimitedReleaseDetailLoad());
    return new Promise((resolve, reject) => {
      hmplusLimitedReleasesDetailService
        .removeTargetHMplusLimitedReleaseDetail(queryParams)
        .then(
          (data) => {
            dispatch(removeTargetHMplusLimitedReleaseDetailSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(
              removeTargetHMplusLimitedReleaseDetailFailure(error?.toString())
            );
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function activateHMplusLimitedReleaseDetail(queryParams) {
  function activateHMplusLimitedReleaseDetailLoad() {
    return {
      type: activateHMplusLimitedReleaseDetailConstants.ACTIVATE_HMPLUS_LIMITED_RELEASE_DETAIL_LOADING,
    };
  }
  function activateHMplusLimitedReleaseDetailSuccess(data) {
    return {
      type: activateHMplusLimitedReleaseDetailConstants.ACTIVATE_HMPLUS_LIMITED_RELEASE_DETAIL_SUCCESS,
      data,
    };
  }
  function activateHMplusLimitedReleaseDetailFailure(error) {
    return {
      type: activateHMplusLimitedReleaseDetailConstants.ACTIVATE_HMPLUS_LIMITED_RELEASE_DETAIL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(activateHMplusLimitedReleaseDetailLoad());
    return new Promise((resolve, reject) => {
      hmplusLimitedReleasesDetailService
        .activateHMplusLimitedReleaseDetail(queryParams)
        .then(
          (data) => {
            dispatch(activateHMplusLimitedReleaseDetailSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(
              activateHMplusLimitedReleaseDetailFailure(error?.toString())
            );
            reject(error);
          }
        );
    });
  };
}

function deactivateHMplusLimitedReleaseDetail(queryParams) {
  function deactivateHMplusLimitedReleaseDetailLoad() {
    return {
      type: deactivateHMplusLimitedReleaseDetailConstants.DEACTIVATE_HMPLUS_LIMITED_RELEASE_DETAIL_LOADING,
    };
  }
  function deactivateHMplusLimitedReleaseDetailSuccess(data) {
    return {
      type: deactivateHMplusLimitedReleaseDetailConstants.DEACTIVATE_HMPLUS_LIMITED_RELEASE_DETAIL_SUCCESS,
      data,
    };
  }
  function deactivateHMplusLimitedReleaseDetailFailure(error) {
    return {
      type: deactivateHMplusLimitedReleaseDetailConstants.DEACTIVATE_HMPLUS_LIMITED_RELEASE_DETAIL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(deactivateHMplusLimitedReleaseDetailLoad());
    return new Promise((resolve, reject) => {
      hmplusLimitedReleasesDetailService
        .deactivateHMplusLimitedReleaseDetail(queryParams)
        .then(
          (data) => {
            dispatch(deactivateHMplusLimitedReleaseDetailSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(
              deactivateHMplusLimitedReleaseDetailFailure(error?.toString())
            );
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function deleteHMplusLimitedReleaseDetail(queryParams) {
  function deleteHMplusLimitedReleaseDetailLoad() {
    return {
      type: deleteHMplusLimitedReleaseDetailConstants.DELETE_HMPLUS_LIMITED_RELEASE_DETAIL_LOADING,
    };
  }
  function deleteHMplusLimitedReleaseDetailSuccess(data) {
    return {
      type: deleteHMplusLimitedReleaseDetailConstants.DELETE_HMPLUS_LIMITED_RELEASE_DETAIL_SUCCESS,
      data,
    };
  }
  function deleteHMplusLimitedReleaseDetailFailure(error) {
    return {
      type: deleteHMplusLimitedReleaseDetailConstants.DELETE_HMPLUS_LIMITED_RELEASE_DETAIL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(deleteHMplusLimitedReleaseDetailLoad());
    return new Promise((resolve, reject) => {
      hmplusLimitedReleasesDetailService
        .deleteHMplusLimitedReleaseDetail(queryParams)
        .then(
          (data) => {
            dispatch(deleteHMplusLimitedReleaseDetailSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(
              deleteHMplusLimitedReleaseDetailFailure(error?.toString())
            );
            errorExtractor(error, reject);
          }
        );
    });
  };
}

export const hmplusLimitedReleasesDetailActions = {
  getHMplusLimitedReleaseDetail,
  createHMplusLimitedReleaseDetail,
  editHMplusLimitedReleaseDetail,
  addTargetHMplusLimitedReleaseDetail,
  removeTargetHMplusLimitedReleaseDetail,
  activateHMplusLimitedReleaseDetail,
  deactivateHMplusLimitedReleaseDetail,
  deleteHMplusLimitedReleaseDetail,
};
